<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

  created() {
    const that = this
    window.onstorage = function (e) {
      // console.log(`The ${e.key}  key has been changed from ${e.oldValue}  to  ${e.newValue} .`)
      that.$router.push('/login')
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
@import "~@/assets/style/public-class.scss";

.el_table {
  thead {
    th {
      background: #f5f7fa;
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
